<div class="titlebar">
  <h3>{{ "Template.MainComponent.subHeader_adminHomepage" | translate }}</h3>
</div>

@if (unavailable) {
  <div>
    <div class="alert alert-danger">
      <fa-icon icon="triangle-exclamation" size="3x"></fa-icon>
      <span>{{ "Template.MainComponent.msg_mediaCenterUnavailable" | translate }}</span>
    </div>
  </div>
}

<div>
  <div class="row">
    <div class="col-md-6 col-xs-12">
      <h5>{{ "Template.MainComponent.label_sftpCredentials" | translate }}</h5>
      @if (!loaded['FTP_ACCOUNTS']) {
        <div>
          <fa-icon icon="spinner" animation="spin"></fa-icon>
        </div>
      }

      @if (loaded['FTP_ACCOUNTS'] && sftpAccounts && sftpAccounts.length) {
        <div>
          @for (account of sftpAccounts; track account) {
            <div>
              <table class="table">
                <tbody>
                  <tr>
                    <th scope="row">{{ "Template.MainComponent.label_host" | translate }}:</th>
                    <td>{{ account.host! }}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{ "Template.MainComponent.label_port" | translate }}:</th>
                    <td>{{ account.port! }}</td>
                  </tr>
                  <tr>
                    <th scope="row">{{ "Template.MainComponent.label_username" | translate }}:</th>
                    <td>{{ account.username! }}</td>
                  </tr>
                  <tr>
                    <th scope="row" class="border-bottom-0">{{ "Template.MainComponent.label_password" | translate }}:</th>
                    <td class="border-bottom-0">{{ account.password! }}</td>
                  </tr>
                </tbody>
              </table>
              <hr />
            </div>
          }
        </div>
      }
    </div>

    <div class="col-md-6 col-xs-12">
      <h5>{{ "Template.MainComponent.label_sftpStatus" | translate }}</h5>
      @if (!loaded['SYSTEM_INFORMATION']) {
        <div>
          <fa-icon icon="spinner" animation="spin"></fa-icon>
        </div>
      }

      @if (loaded['SYSTEM_INFORMATION'] && systemInformation) {
        <div>
          <table class="table">
            <tbody>
              <tr>
                <th scope="row">{{ "Template.MainComponent.label_host" | translate }}:</th>
                <td>{{ systemInformation.sftHost! }}</td>
              </tr>
              <tr>
                <th scope="row">{{ "Template.MainComponent.label_port" | translate }}:</th>
                <td>{{ systemInformation.sftpPort! }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      }
    </div>

    <div class="col-12">
      <h5>{{ "Template.MainComponent.subHeader_adminAccesses" | translate }}</h5>
      @if (!loaded['ADMIN_USERS']) {
        <div>
          <fa-icon icon="spinner" animation="spin"></fa-icon>
        </div>
      }

      @if (loaded['ADMIN_USERS'] && systemInformation) {
        <div>
          <table class="table">
            <tbody>
              @for (employee of adminUsers; track employee) {
                <tr class="border-bottom">
                  <td>
                    <app-employee [username]="employee" [isAdmin]="true" (loadingEvent)="showLoader($event)" (reloadEvent)="loadAdminUsers()"></app-employee>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  </div>
</div>
